// extracted by mini-css-extract-plugin
module.exports = {"root":"FloatingBackButton_root__1fLGZ","hidden":"FloatingBackButton_hidden__nMbtJ","hide":"FloatingBackButton_hide__3EhW-","spin":"FloatingBackButton_spin__2xQgk"};